// Write your code here
import './TabFirst.css'

const TabFirst = props => {
  const {tabname, onchangestatus, isActive} = props
  const {tabId, displayText} = tabname
  const appclick = () => {
    onchangestatus(tabId)
  }
  const activeTabBtnClassName = isActive ? 'active-tab-btn' : 'button'

  return (
    <li className="tabcontainer">
      {/* <button
        type="button"
        className={`tab-btn ${activeTabBtnClassName}`}
        onClick={appclick}
      >
        {displayText}
      </button> */}

      <button className={`newbutton  ${activeTabBtnClassName}`} onClick={appclick}> {displayText}
      </button>

    </li>
  )
}
export default TabFirst
